import { render } from "./multislide.vue?vue&type=template&id=6ecd89b4"
import script from "./multislide.vue?vue&type=script&lang=js"
export * from "./multislide.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__